<template>
  <div
    :style="{ '--height': height, width }"
    @click="$emit('click')"
    class="button"
    :class="variant"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    variant:{
      type: String,
      default: 'fill'
    },
    height: {
      type: String,
      default: "2.5rem",
    },
    width: {
      type: String,
      default: "6rem",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/color.scss";
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(../../assets/btnBg.png) no-repeat center;
  cursor: pointer;
  background-size: cover;
  height: var(--height);
  border-radius: var(--height);
  line-height: var(--height);
  color: #fff;
  &.plain {
    background: none;
    border: 1px solid $themeColor;
    color: $themeColor;
  }
}
</style>
